import { render, staticRenderFns } from "./DocumentK3L.vue?vue&type=template&id=a6657128&"
import script from "./DocumentK3L.vue?vue&type=script&lang=js&"
export * from "./DocumentK3L.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports